document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".features__tabs-button");
  const tabItems = document.querySelectorAll(".features__tabs-item");

  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      // Remove active class from all buttons and items
      tabButtons.forEach((btn) =>
        btn.classList.remove("features__tabs-button-active")
      );
      tabItems.forEach((item) =>
        item.classList.remove("features__tabs-item-active")
      );

      // Add active class to clicked button and corresponding content
      button.classList.add("features__tabs-button-active");
      const tabId = button.getAttribute("data-tab");
      document
        .querySelector(`.features__tabs-item-${tabId}`)
        .classList.add("features__tabs-item-active");
    });
  });

  // Set the first tab as active by default
  tabButtons[0].classList.add("features__tabs-button-active");
  tabItems[0].classList.add("features__tabs-item-active");
});
